import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { environment } from '@env/environment.prod';
import { HttpClient } from '@angular/common/http/';

@Injectable({
  providedIn: 'root'
})
export class ReporteVentaService extends BaseAPIClass {
  baseUrl = '';
  public isLoading = false;
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/reporte';
  }

  ventasReporte(object: any) {
    return this.httpClient.post(this.baseUrl + '/ventas', object);
  }

  

  // detalleId(id:string){
  //   return this.httpClient.get(this
  // }
}
